/* eslint-disable eqeqeq */
import InputCurrency from 'components/InputCurrency'
import InputJumlah from 'components/InputJumlah'
import { useEffect, useState } from 'react'
import { Calendar, HelpCircle } from 'react-feather'
import {
  Alert,
  Card,
  CardText,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from 'reactstrap'
// api
import useGetCommodityQuery from 'hooks/useGetCommodityQuery'
import {
  useCreateAutoRepoMutation,
  useGetRepoTopThreeQuery,
} from '../commodityRepoApiSlice'

import CustomButton from 'components/Buttons/CustomButton'
import InputCurrencyWithLimit from 'components/InputCurrencyWithLimit'
import useAutoFetchPublicVersion from 'hooks/useAutoFetchPublicVersion'
import moment from 'moment-timezone'
import Flatpickr from 'react-flatpickr'
import { useSelector } from 'react-redux'
import Select from 'react-select'
import SelectInputWithTestId from 'components/PMBSelect/SelectInputWithTestId'
import CardTop from '../components/CardTop'
import ModalConfirmSave from '../components/ModalConfirmSave'

const RepoCommodityForm = ({ invoiceLinks }) => {
  const getCommodity = useGetCommodityQuery()
  useAutoFetchPublicVersion()

  const { data } = useSelector((state) => state.publicVersion)

  const [{ isLoading }] = useCreateAutoRepoMutation()
  const getTopThree = useGetRepoTopThreeQuery()

  // Options
  const [commodity, setCommodity] = useState([])
  const [listComodities, setListComodities] = useState([])
  const [units, setUnits] = useState([])
  // List Payload
  const [saveData, setSaveData] = useState(true)
  const [name, setName] = useState('')
  const [sku, setSku] = useState('')
  const [invoiceDate, setInvoiceDate] = useState('')
  const [unitAmount, setUnitAmount] = useState('')
  const [unitName, setUnitName] = useState('')
  const [amountInvoice, setAmountInvoice] = useState(0)
  const [amountRequested, setAmountRequested] = useState(0)
  const [repoNotes, setRepoNotes] = useState('')
  let invLink = invoiceLinks.map((obj) => obj.url).join(',')

  // State Confirm
  const [isConfirm, setIsConfirm] = useState(false)

  const handleSubmit = () => {
    if (saveData) {
      setIsConfirm(true)
    } else {
      setIsConfirm(true)
    }
  }

  const handleInputFormTopThree = (payload) => {
    let date = new Date(payload?.invoiceDate)

    let year = date.getFullYear()
    let month = String(date.getMonth() + 1).padStart(2, '0')
    let day = String(date.getDate()).padStart(2, '0')

    let thisCommodity =
      listComodities[0]?.options?.find((i) => i.value === payload?.SKU) ||
      listComodities[1]?.options?.find((i) => i.value === payload?.SKU)

    if (thisCommodity) {
      setName(payload?.name)
      setCommodity([{ value: thisCommodity.value, label: thisCommodity.label }])
      setSku(payload?.SKU)
      setUnits([{ value: payload?.unitName, label: payload?.unitName }])
      setUnitName(payload?.unitName)
      setInvoiceDate(`${year}-${month}-${day}`)
      setUnitAmount(formatCurrency(payload?.unitAmount))
      setAmountInvoice(formatCurrency(payload?.amountInvoice))
      setAmountRequested(formatCurrency(payload?.amountRequested))
    }

    function formatCurrency(amount) {
      let formattedAmount = new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
      })
        .formatToParts(amount)
        .slice(1)
        .map((part) => part.value)
        .join('')

      if (formattedAmount.includes(',')) {
        let parts = formattedAmount.split(',')
        if (parts[1] == '00') {
          return parts[0]
        } else {
          return formattedAmount
        }
      } else {
        return formattedAmount.replace('.00', '')
      }
    }
  }

  function convertStrToNum(amountReq, amountInv) {
    let req = amountReq?.toString()
    req = parseInt(req?.replace(/\./g, ''))

    let inv = amountInv?.toString()
    inv = parseInt(inv?.replace(/\./g, ''))

    if (req > inv) {
      return true
    } else {
      return false
    }
  }

  const handleLastPick = (e) => {
    const newListComodities = [...listComodities]

    const updatedOptions = newListComodities[0]?.options?.filter(
      (item) => item.id !== e.id,
    )

    updatedOptions.unshift(e)

    if (updatedOptions.length > 5) {
      const removedItem = updatedOptions.pop()

      newListComodities[1] = {
        ...newListComodities[1],
        options: [...newListComodities[1].options, removedItem],
      }
    }

    newListComodities[0] = {
      ...newListComodities[0],
      options: updatedOptions,
    }

    newListComodities[1] = {
      ...newListComodities[1],
      options: newListComodities[1].options.filter((item) => item.id !== e.id),
    }

    localStorage.setItem(
      'lastPickedCommoditiesBuy',
      JSON.stringify(updatedOptions),
    )

    setListComodities(newListComodities)
  }

  useEffect(() => {
    if (amountRequested !== undefined && amountInvoice !== undefined) {
      convertStrToNum(amountRequested, amountInvoice)
    }
  }, [amountInvoice, amountRequested])

  useEffect(() => {
    if (getCommodity?.data.length > 0 && !getCommodity?.isLoading) {
      setListComodities(getCommodity?.data)
    }
  }, [getCommodity?.data.length > 0])

  useEffect(() => {
    if (data?.unitArray.length > 0) {
      setUnits(data?.unitArray?.find((e) => e?.label === 'Kg'))
    }
  }, [data])

  return (
    <>
      <Card body className="my-3 border-0 shadow-sm" style={{ padding: 32 }}>
        <CardText className="text-md fw-bold">Repo Barang</CardText>
        <Alert
          color="success"
          className="text-xs fw-semibold"
          style={{ backgroundColor: '#ECFDF3' }}
        >
          <HelpCircle size={16} className="me-2" style={{ color: '#027A48' }} />
          <span>
            Pastikan informasi yang diisi sama dengan dokumen repo yang di
            unggah
          </span>
        </Alert>

        {/* Start Top Three */}
        <Row>
          {getTopThree?.data?.map((topThree, i) => (
            <Col key={i} lg={4} className="mb-3">
              <CardTop data={topThree} callBack={handleInputFormTopThree} />
            </Col>
          ))}
        </Row>
        {/* End Top Three */}
        <Form>
          {/* name */}
          <FormGroup>
            <Label for="name" className="text-sm">
              Nama usaha penjamin repo
            </Label>
            <Input
              id="name"
              name="name"
              placeholder="Masukkan nama usaha"
              type="text"
              autoComplete="off"
              className="text-sm"
              onChange={(e) => setName(e.target.value)}
              value={name}
              data-testid="repo-form-name"
            />
          </FormGroup>

          {/* SKU */}
          <FormGroup data-testid="repo-form-nameItem">
            <Label for="name" className="text-sm">
              Barang yang di repo
            </Label>
            <Select
              id="nameItem"
              name="nameItem"
              placeholder="Pilih barang"
              options={listComodities ?? []}
              onChange={(e) => {
                setCommodity([{ value: e.SKU, label: e.label }])
                setSku(e.SKU)
                handleLastPick(e)
              }}
              value={commodity ?? []}
              components={{ Input: SelectInputWithTestId }}
              data-testid="repo-form-nameItem"
            />
          </FormGroup>

          {/* invoiceDate */}
          <FormGroup>
            <Label for="name" className="text-sm">
              Pilih tanggal barang akan dibayarkan oleh penjamin repo
            </Label>
            {/* <Input
              id="name"
              name="name"
              placeholder="Pilih barang"
              type="date"
              lang="id-ID"
              autoComplete="off"
              className="text-sm"
              onChange={(e) => setInvoiceDate(e.target.value)}
              value={invoiceDate}
            /> */}
            <div
              className="d-flex align-items-center justify-content-center border rounded"
              data-testid="repo-form-invoiceDate"
            >
              <Calendar size={17} className="ms-3" />
              <Flatpickr
                options={{
                  dateFormat: 'd-M-Y',
                  defaultDate: invoiceDate,
                  onClose: (selectedDate, dateStr, instance) => {
                    setInvoiceDate(
                      moment(selectedDate[0]).local().format('YYYY-MM-DD'),
                    )
                  },
                }}
                className="form-control flat-picker bg-transparent border-0 shadow-none"
              />
            </div>
          </FormGroup>
          {/* multi form */}
          <Row>
            <Col sm={12} md={12} lg={6}>
              <FormGroup>
                <Label for="name" className="text-sm">
                  Jumlah
                </Label>
                <InputJumlah
                  id="jumlah"
                  name="jumlah"
                  setValue={(e) => setUnitAmount(e)}
                  value={unitAmount}
                  testId="repo-form-jumlah"
                />
              </FormGroup>
            </Col>
            <Col sm={12} md={12} lg={6}>
              <FormGroup data-testid="repo-form-unit">
                <Label for="name" className="text-sm">
                  Satuan
                </Label>
                <Select
                  id="unit"
                  name="unit"
                  placeholder="Pilih Satuan"
                  options={data?.unitArray ?? []}
                  onChange={(e) => {
                    setUnits([{ value: e.value, label: e.label }])
                    setUnitName(e.value)
                  }}
                  value={units ?? []}
                  components={{ Input: SelectInputWithTestId }}
                  data-testid="repo-form-unit"
                />
              </FormGroup>
            </Col>
            <Col sm={12} md={12} lg={6}>
              <FormGroup>
                <Label for="name" className="text-sm">
                  Harga total barang
                </Label>
                <InputCurrency
                  value={amountInvoice}
                  setValue={(e) => {
                    if (
                      amountInvoice !== 0 &&
                      amountRequested !== 0 &&
                      amountInvoice <= amountRequested
                    ) {
                      setAmountRequested(0)
                    }
                    setAmountInvoice(e)
                  }}
                  name="totalPrice"
                  id="totalPrice"
                  testId="repo-form-totalPrice"
                />
              </FormGroup>
            </Col>
            <Col sm={12} md={12} lg={6}>
              <FormGroup>
                <Label for="name" className="text-sm">
                  Permintaan untuk limit talangin
                </Label>
                <InputCurrencyWithLimit
                  maxAmount={amountInvoice}
                  value={amountRequested}
                  name="amountRequested"
                  id="amountRequested"
                  setValue={(e) => setAmountRequested(e)}
                  testId="repo-form-amountRequested"
                />
                <span style={{ color: '#DC6803' }} className="text-sm">
                  Harga permintaan harus dibawah harga total barang
                </span>
              </FormGroup>
            </Col>

            <Col sm={12}>
              <FormGroup>
                <Label for="catatan" className="text-sm">
                  Catatan
                </Label>
                <Input
                  type="textarea"
                  value={repoNotes}
                  name="notes"
                  id="notes"
                  onChange={(e) => setRepoNotes(e.target.value)}
                  data-testid="repo-form-notes"
                />
              </FormGroup>
            </Col>

            <Col sm={12} md={12} lg={6}>
              <div className="d-flex flex-column text-wrap w-auto">
                <div className="mb-1 p-2">
                  <Input
                    type="checkbox"
                    checked={saveData}
                    className="me-2"
                    onChange={(e) => setSaveData(e.target.checked)}
                  />
                  <span className="text-sm">
                    Simpan Data Ini Untuk Repo Berikutnya
                  </span>
                </div>
              </div>
            </Col>
          </Row>
        </Form>
        <hr />
        <Row className="">
          <Col className="d-flex align-items-center">
            <span>
              <span className="fw-bold">Harga permintaan Repo:</span> Rp
              {`${amountRequested}`}
            </span>
          </Col>
          <Col className="d-flex align-items-center justify-content-end">
            <CustomButton
              color="primary"
              disabled={
                !sku ||
                invLink === '' ||
                !invoiceDate ||
                !name ||
                !unitName ||
                amountInvoice == '0' ||
                amountRequested == '0' ||
                unitAmount == '0' ||
                isLoading ||
                convertStrToNum(amountRequested, amountInvoice)
              }
              style={{ padding: '16px 28px' }}
              onClick={handleSubmit}
            >
              Ajukan Permintaan Repo
            </CustomButton>
          </Col>
        </Row>
      </Card>
      <ModalConfirmSave
        isOpen={isConfirm}
        toggle={() => setIsConfirm(false)}
        payload={{
          SKU: sku,
          amountInvoice,
          amountRequested,
          invoiceLinks: invLink,
          invoiceDate,
          name: name.trim(),
          unitName,
          unitAmount,
          save: saveData,
          notes: repoNotes,
        }}
      />
    </>
  )
}

export default RepoCommodityForm
